import { render, staticRenderFns } from "./TranslationPreview.vue?vue&type=template&id=98766ac0&"
import script from "./TranslationPreview.vue?vue&type=script&lang=js&"
export * from "./TranslationPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports